import {
  isShortLink,
  LocalStorage,
  MAIN_TOKEN_ID_KEY,
  type OldShortLink,
  RESERVATION_ID_KEY,
  type ShortLink,
} from '@chekin/core';

const getReservationFromStorage = () => {
  const currentReservationId = LocalStorage.get(RESERVATION_ID_KEY);
  const storedMainTokenIdKey = LocalStorage.get(MAIN_TOKEN_ID_KEY);
  const [, , , token] = window.location.href.split('/');
  const isIdRelevant = storedMainTokenIdKey === token;

  if (isIdRelevant) {
    return (
      currentReservationId?.toString() ?? import.meta.env.VITE_APP_TEST_RESERVATION_ID
    );
  }
};

const getTemplateId = (data?: OldShortLink | ShortLink) => {
  if (isShortLink(data)) {
    return data?.branding_template;
  }
};

export {getReservationFromStorage, getTemplateId};
